import { defineMessages } from 'react-intl';

export default defineMessages({
  addToReportDrawerTitle: 'Add to report',
  addToReportSuccess: 'Chart added to {title}',
  addToReportError: 'Failed to add chart to {title}. Please try again.',

  noCharts: 'Survey contains no charts for this page',
  crossTabulate: 'Cross tabulation',
  chartSegment: 'Chart segment',
});
